import React from 'react';
import { Dropdown, Space } from 'antd';
import type { MenuProps } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const items: MenuProps['items'] = [
    { key: 'zh', label: '简体中文' },
    { key: 'en', label: 'English' },
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    i18n.changeLanguage(key);
  };

  const currentLabel = i18n.language?.startsWith('zh') ? '中文' : 'EN';

  return (
    <Dropdown menu={{ items, onClick }} placement="bottomRight">
      <Space style={{ cursor: 'pointer' }}>
        <GlobalOutlined />
        <span>{currentLabel}</span>
      </Space>
    </Dropdown>
  );
};

export default LanguageSwitcher;
